import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { DraggableComponentProps } from 'features/document/constants';
import { isContractInfoTableElement } from 'utils/typeGuards';
import '../Table/Table.css';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectContract } from 'features/salesforce/salesforceSlice';
import { updateElementById } from 'features/document/documentSlice';

export default function ContractInfoTable({ currentElement }: DraggableComponentProps) {
  if (!isContractInfoTableElement(currentElement)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const contract = useAppSelector(selectContract);

  const tableContent = currentElement.content;
  const { header, rows, cells } = tableContent;

  useEffect(() => {
    const {
      OwnerName,
      ContractNumber,
      StartDate,
      EndDate,
      ContractTerm,
      SpecialTerms,
      OwnerExpirationNotice,
      Description,
    } = contract;

    const newContent = {
      ...tableContent,
      cells: {
        ...cells,
        'cell-2': { id: 'cell-2', content: OwnerName || '' },
        'cell-4': { id: 'cell-2', content: ContractNumber || '' },
        'cell-6': { id: 'cell-2', content: StartDate || '' },
        'cell-8': { id: 'cell-2', content: EndDate || '' },
        'cell-10': { id: 'cell-2', content: ContractTerm || '' },
        'cell-12': { id: 'cell-12', content: SpecialTerms || '' },
        'cell-14': { id: 'cell-2', content: OwnerExpirationNotice || '' },
        'cell-16': { id: 'cell-16', content: Description || '' },
      },
    };

    dispatch(
      updateElementById({
        elementId: currentElement.id,
        content: newContent,
        style: {},
      })
    );
  }, [dispatch, contract]);

  const renderCell = (cellContent: string) => {
    return <span>{cellContent}</span>;
  };

  const renderTableHeader = () => {
    return (
      <thead>
        <tr>
          <th
            className='pricingHeader'
            colSpan={2}
            key={header.id}
            style={{ display: header.hidden ? 'none' : 'table-cell', fontWeight: 500 }}
          >
            {header.header}
          </th>
        </tr>
      </thead>
    );
  };

  const renderTableBody = () => {
    return (
      <tbody>
        {rows.map(row => {
          if (row.hidden) {
            return;
          }
          return (
            <tr className={'row contractRow'} key={row.id}>
              {row.cellIds.map((cellId, cellIndex) => {
                const cell = cells[cellId];
                return (
                  <td
                    className='contractCell'
                    colSpan={cell.colSpan}
                    key={cell.id}
                    style={{
                      display: cell.hidden ? 'none' : 'table-cell',
                      width: cellIndex ? '100%' : '35%',
                      fontWeight: cellIndex ? 400 : 500,
                    }}
                  >
                    {renderCell(cell.content)}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    );
  };

  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'} gap={'32px'}>
      <table className='table'>
        {renderTableHeader()}
        {renderTableBody()}
      </table>
    </Box>
  );
}
